export function isEnum<T extends string>(value: string, enumName: Record<string, T>): value is T {
  return Object.values(enumName).includes(value as T);
}
